import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TopBarComponent } from '../shared/top-bar/top-bar.component';

@Component({
  selector: 'app-full',
  standalone: true,
  imports: [TopBarComponent, RouterOutlet, NgxSpinnerModule],
  template: `
    <app-top-bar class="header-container"></app-top-bar>
    <div class="px-0 container-fluid main-container">
      <router-outlet/>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .header-container{
        height:58px;
      }
      .main-container {
        overflow: hidden;
        height: calc(100vh - 58px);
      }
    `,
  ],
})
export class FullComponent { }
